module.exports = __webpack_public_path__ + "static/media/40@2x.2c7c4603.png";